import { render, staticRenderFns } from "./Historical2.vue?vue&type=template&id=c528ce12&"
import script from "./Historical2.vue?vue&type=script&lang=js&"
export * from "./Historical2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports